import classNames from "classnames";
import React, { Component } from "react";
import { L10nHtml } from "../i18n";
import { logger } from "../utils";
import styles from "./errorBoundary.css";

type State = { hasError: boolean };

export const DefaultErrorFallback: React.StatelessComponent = () => (
  <div className={styles["error-container"]}>
    <i className={classNames("icon-exclamation-mark", styles.icon)} />
    <p>
      <L10nHtml id={"error.componentDidCatch"} />
    </p>
  </div>
);

export function withErrorBoundary<P>(
  SafeComponent: React.ComponentClass<P> | React.StatelessComponent<P>,
  Fallback = DefaultErrorFallback
): typeof SafeComponent {
  return class extends Component<P, State> {
    state = { hasError: false };

    componentDidCatch(error: Error) {
      logger.error({ message: "Error boundary caught error", error });
      this.setState({ hasError: true });
    }

    render() {
      return this.state.hasError ? <Fallback /> : <SafeComponent {...this.props} />;
    }
  };
}
